
export default [
	{
		notificationMessage: "Nu aveti nici un mesaj",
		// dashboard
		welcomeTitle: "{name}, bine ai venit!",
		welcomeMessage: "Ne bucuram ca ai ales sa te alaturi Up Club. ",

		textButtonDiscover: "Descopera",
		image1Text: "Aici vei putea sa descoperi ofertele produselor si serviciilor partenerilor  Up Club ",
		image2Text: "Aici vei putea sa descoperi evenimentele partenerilor  Up Club ",
		image3Text: "Aici vei putea sa descoperi training-urile partenerilor  Up Club ",
		dashboardTitle: "Ce este UpClub?",
		dashboardMessage: "Platforma de networking si sales, in care antreprenorii se conecteaza si beneficiaza de oferte, evenimente si training-uri de la business-uri din multiple domenii.",

		// login form page
		companiesLabel: "COMPANII",
		cardUsersMultibenefitsLabel: " SALARIATI",
		confirmButtonLabel: "CONFIRMA",
		cardUserFieldLabel: "E-mail",
		userFieldLabel: "Utilizator",
		passwordFieldLabel: "Parola",
		loginTitle: " Acceseaza contul",
		loginHelpLink: " Ai probleme de autentificare?",
		forgotPasswordLink: "Ai uitat parola?",
		createAccountLink: " Nu ai inca un cont? Inscrie-te aici",
		loginButtonLabel: "LOGIN",
		customerHelpPopup:
			"Daca esti client sau partener afiliat poti accesa platforma uponline folosind informatiile primite in e-mailul de bun venit, imediat dupa inregistrarea contractului.  <br/> <br /> Informatiile de log in initiale sunt: <br /> <b>  Utilizator  </b>  = codul unic de client sau afiliat;<br /> <b> Parola  </b>  = codul fiscal al companiei. <br /> Parola trebuie schimbata dupa prima logare. ",
		customerMultibenefitsHelpPopup:
			"Daca esti client poti accesa platforma Up MultiBeneficii folosind informatiile primite in e-mailul de bun venit, imediat dupa inregistrarea contractului.  <br/> <br /> Informatiile de log in initiale sunt: <br /> <b>  Utilizator  </b>  = codul unic de client;<br /> <b> Parola  </b>  = codul fiscal al companiei. <br /> Parola trebuie schimbata dupa prima logare. ",
		userLoginHelpPopup:
			"Salut! Te anuntam ca am schimbat modalitatea de autentificare pentru utilizatorii de carduri. Te rugam sa iti creezi un cont nou folosind o adresa de e-mail si datele de identificare cerute. <br /> Vei putea folosi acest cont si pentru a te autentifica in aplicatia Up Mobil.",
		downloadAppMessage: "Descarca noua aplicatie Up Mobil",
		loadingPopupMessage: " Te rugam sa astepti. Pagina se incarca...",
		errorMessage_user_blocked: "Utilizatorul este blocat",
		errorMessage_invalid_grant: "Utilizatorul sau parola sunt invalide!",

		errorMessage_invalid_login: "Utilizatorul sau parola sunt invalide!",
		errorMessageResetPassword_PSBC:
			"Informatiile de autentificare nu sunt valide",
		errorMessageResetPassword_bad_credentials:
			"Cod companie sau cod fiscal invalid",
		errorMessage_undefined:
			" Serverul nu raspunde. <br /> Te rugam sa astepti cateva minute si sa incerci din nou.",
		errorMessage_invalid_client:
			" Serverul nu raspunde. <br /> Te rugam sa astepti cateva minute si sa incerci din nou.",
		errorMessage_server_error:
			" Serverul nu raspunde. <br /> Te rugam sa astepti cateva minute si sa incerci din nou.",
		errorMessageResetPassword_server_error:
			" Serverul nu raspunde. <br /> Te rugam sa astepti cateva minute si sa incerci din nou.",

		// create account page
		createAccountTitle: " Hai sa ne cunoastem!",
		createAccountAlready: " Ai deja cont? ",
		createAccountLogin: " Logare ",

		error_BPIP: "Parola este invalida",
		error_UC01: "Invitatia a expirat",
		error_LS06: "Invitatia a expirat",
		error_LS12: "Prenumele poate contine maxim 40 de caractere",
		error_LS13: "Numele poate contine maxim 40 de caractere",
		error_500: "Server error",

		error_OFFER_NAME_INVALID: "Numele produsului este invalid",
		error_OFFER_DESCRIPTION_INVALID: "Descrierea ofertei este invalida",
		error_OFFER_DESCRIPTION_TOO_LONG: "Descrierea ofertei poate contine maxim 1000 de caractere",
		error_OFFER_MEASURE_INVALID: "Unitatea de masura este invalid",
		error_OFFER_LOCATION_INVALID: "Locul de desfasurare este invalid",
		error_START_DATE_TOO_BIG: "Data de start este invalida",
		error_VALIDITY_START_DATE_TOO_BIG: "Data de start a valabilitatii este invalida",
		error_IMAGE_MANDATORY: "Imaginea este obligatorie",
		error_PRICE_DEDUCTION: "Valoare deductiei nu poate fi mai mare ca pretul ofertei",
		error_PRICE_DISCOUNT: "Valoare discountului nu poate fi mai mare ca 100 %",
		error_OFFER_LIST_EMPTY: "Nu ati selectat nici o oferta",
		termsAcceptButton: "ACCEPTA TERMENII SI CONDITIILE",

		error_NOT_IMPLEMENTED: "Aceasta actiune nu este implementata",

		error_EMAIL_EMPTY: "Este necesara completarea campului email.",
		error_EMAIL_INVALID: "Adresa de email este invalida.",
		error_500:
			"Serverul nu raspunde. <br /> Te rugam sa astepti cateva minute si sa incerci din nou.",
		error_401:
			"Serverul nu raspunde. <br /> Te rugam sa astepti cateva minute si sa incerci din nou.",
		error_400:
			"Serverul nu raspunde. <br /> Te rugam sa astepti cateva minute si sa incerci din nou.",

		error_FRIEND_ALREADY: "Aceasta persoana este deja in lista de prieteni",

		registrationCheckDataTitle: "Verifica informatiile sau modifica datele",
		surnameFieldLabel: "Prenume",
		lastNameField: "Nume",
		emailField: "E-mail",
		mobileField: "Telefon",
		setPasswordTitle: "Insereaza parola",
		passwordField: "Parola noua",
		confirmPasswordField: "Confirma parola noua",
		invalidPasswordMessage: "Parola invalida",
		successMessageTitle: "Felicitari!",
		registrationSuccessMessage:
			"A fost trimis un e-mail de bun venit la adresa",
		flexAccountSuccessMessage:
			"Ai activat cu succes contul de Up MultiBeneficii pentru adresa de e-mail:",
		flexAccountAlreadyCreated:
			"Ai deja un cont inregistrat in platforma uponline, cu numele de utilizator <b>{email}</b> <br /> Pentru a activa beneficiile Up MultiBeneficii in contul tau mergi la pasul urmator.",
		flexAccountNew:
			" Pentru a gestiona beneficiile oferite de angajator, te rugam sa creezi un cont nou.",

		// forgot password
		forgotPasswordTitle: "Ai uitat parola?",
		resetPasswordTitle: "Reseteaza parola",
		otpResendText: "Retrimite codul OTP",
		resetPasswordSuccessMessage: "Parola a fost resetata cu succes",
		companyCodeLabel: "Cod companie",
		fiscalCodeLabel: "Cod fiscal",
		companyCodeOrEmailLabel: "Cod companie",
		fiscalCodeOrCodeCompanyLabel: "Cod fiscal",
		forgotPasswordMessage:
			"	Te rugam sa introduci adresa de e-mail pentru a schimba parola.",
		forgotPasswordMessageOTP:
			"	Te rugam sa introduci codul OTP primit pe e-mail.",

		resetPasswordSuccessMessageCompany:
			"A fost transmis un email ce contine link-ul de schimbare a parolei",
		resetPasswordMessageCompany:
			"	Te rugam sa introduci noua parola pentru <br /> contul companiei tale.",
		// cookies box
		cookiesBoxText:
			"Site-ul nostru foloseste cookie-uri pentru a-ti afisa continut personalizat. Tot cookie-uri foloseste si serviciul de monitorizare statistics de trafic in site, serviciu oferit de Google. <br />Te rugam sa citesti politica noastra si sa iti exprimi preferintele legate de cookie-uri.",
		cookiesAcceptBotton: "ACCEPTA",
		cookiesCookiePreferences: "PREFERINTE COOKIES",
		notificationsTitle: "Optiuni notificari",
		notificationsTransactionalLabel: "Notificari tranzactionale",
		notificationsMarketingTitle: "Notificari de marketing",
		notificationsLabel: "Notificari",
		notificationsSMSLabel: "SMS",
		notificationsEmailLabel: "E-mail",
		notificationsCongrats:
			"Acum iti poti verifica soldul si poti descoperi partenerii afiliati care accepta cardurile Up Romania",
		completeRegistrationLogin: "INTRA IN CONT!",
		// page name
		searchName: "Cauta",
		dashboardName: "Home",
		offersName: "Oferte dedicate",
		addOfferName: "Adauga produse sau servicii",
		eventsName: "Evenimente",
		trainingsName: "Traininguri",
		profileName: "Profilul meu",
		friendsName: "Prieteni",
		membershipName: "Membership",
		termsAndConditionsName: "Termeni si conditii",
		manageUsersName: "Useri",
		manageAdminsName: "Administratori",
		manageOffersName: "Oferte useri",
		myOffersName: "Ofertele mele",
		// contactName: "Contact",
		// faqName: "Intrebari frecvente",
		logoutName: "Logout",

		offersShortDesc: "Descopera ofertele produselor si serviciilor partenerilor Up Club",
		eventsShortDesc: "Descopera ofertele produselor si serviciilor partenerilor Up Club",
		trainingsShortDesc: "Descopera training-utile partenerilor Up Club",
		addOfferShortDesc: "De aici iti poti modifica setarile si datele profilului tau UpClub.",
		friendsTitle: "Conecteaza-te cu alti antreprenori de succes.",
		friendsShortDesc: "De aici îți poți modifica setările și datele profilului tău UpClub.",

		addOfferChooseType: "Selecteaza tipul:",
		addOfferPreview: "PREVIZUALIZEAZA OFERTA",
		chooseType_OFFER: "OFERTA",
		chooseType_TRAINING: "TRAINING",
		chooseType_EVENT: "EVENIMENT",

		productNameLabel: "Denumirea produsului/serviciului",
		priceLabel: "Pret",
		currencyLabel: "Moneda",
		cityLabel: "Oras",
		companyCityLabel: "Oras Companie",
		companyDescriptionLabel: "Descrierea companiei",
		descriptionLabel: "Descrierea companiei",
		selectLabel: "Selecteaza...",
		measureUnitLabel: "Unitate de masura",
		validityStartLabel: "Valabilitate (de la)",
		validityEndLabel: "Valabilitate (pana la)",
		valabilityLabel: "Valabilitate: <br /> {start_date} - {end_date}",
		discoutTypeLabel: "Tipul ofertei",
		discoutLabel: "Discount (ex. 20% reducere)",
		deductionLabel: "Deductie (ex. -50lei)",
		discountValueLabel: "Discount-ul aplicat",
		locationValueLabel: "Loc desfasurare",
		periodLabel: "Perioada desfasurare: <br /> {start_date} - {end_date}",
		startDateLabel: "Perioada desfasurare (de la)",
		endDateLabel: "Perioada desfasurare (pana la)",
		detailsLabel: "Detalii",
		uploadImageLabel: "Adauga imagine",
		addNewOfferSuccess: "Oferta a fost adaugata cu succes. <br /> Urmeaza sa fie validata de catre un reprezentant Up Romania si apoi publicata",
		modifiyDataSucceess: "Oferta a fost modificata cu succes. <br /> Urmeaza sa fie validata de catre un reprezentant Up Romania si apoi publicata",
		details: "Detalii",
		previewTitle: "PREVIZUALIZEAZA",

		acceptTerms:"Accepta",
		declineTerms: "Refuza",

		saveChangesLabel: "Salveaza",
		cancelChangesLabel: "Anuleaza",
		confirmDeleteAccount: "Esti sigur ca vrei sa stergi contul?",
		confirmDeleteAccountText: "Dacă vei șterge contul va fi șters definitiv.",
		confirmDeleteAccountCancel: "ANULEAZA",
		confirmDeleteAccountConfirm: "DA, STERGE-MI CONTUL",
		backButtonLabel: "Inapoi",

		// profile :
		profileMessage: "Ajuta-i pe ceilalti antreprenori sa te cunoasca si sa te contacteze",
		lastNameLabel: "Nume",
		firstNameLabel: "Prenume",
		companyLabel: "Companie",
		interestsLabel: "Interese",
		mobilePhoneLabel: "Telefon",
		emailLabel: "E-mail",
		websiteLabel: "Site",
		roleCompanyLabel: "Rol",
		openBussinessLabel: "Sunt deschis la business",
		deleteAccountLabel: "Sterge contul",
		changeImageLabel: "Modifica",
		addedByLabel: "Adaugat de: ",
		addOfferLabel: "Adauga oferta",

		askQuestionTitle: "Pune o intrebare",
		askQuestionLabel: "Ai nevoie de ajutor? Lasa-ne un mesaj si te vom contacta in cel mai scurt timp.",
		askQuestionButton: "Pune o intrebare",
		sendButtonLabel: "Trimite",
		questionTitle: "Intrebare",
		askQuestionSuccessMessage: "Mesajul a fost transmis cu succes",


		newsTitle: "Noutati UpRomania",
		seeAllButton: "Vezi toate",


		membershipProfileText: "Descopera beneficii nelimitate in platforma UpClub devenind membru.",

		// friends
		userOffers: "<b>{offers}</b> oferte, <b>{trainings}</b> traininguri, <b>{events}</b> evenimente ",
		activityDomain: "Rol: <b>{domain}</b>",
		cityDomain: "Oras: <b><i>{city}</i></b>",
		companyCityDomain: "Oras companie: <b><i>{city}</i></b>",
		openBussinessYes: "Este deschis la business",
		openBussinessNo: "Nu este deschis la business",
		addFriendLabel: "Adauga",
		browsePersonsLabel: "Descopera",
		personsOffersTitle: "Produse/servicii active",
		personsOffersDesc: "De aici îți poți modifica setările și datele profilului tău UpClub.",
		categoryFilter: "Categoria/interes:",
		sortFilter: "Afiseaza:",
		category_ALL: "Toate",
		category_IT: "IT",
		category_MARKETING: "Marketing",
		sortBy_NEW: "Cele mai noi",
		sortBy_OLD: "Cele mai vechi",

		addNewFriendSuccess: "Felicitari pentru un nou prieten.",
		personModifySuccess: "Modificarea datelor s-a realizat cu succes.",

		// offer management
		managementOffersTitle: "Transfer oferte de la un user la altul",
		managementOffersMarketingTitle: "Verifica lista de produse si servicii incarcate de useri ",
		managementOffersShortDesc: "Ofertele care pleaca de la useri.",
		editOfferButtonLabel: "Editeaza oferta",
		deleteOfferButtonLabel: "Sterge oferta",
		rejectOfferButtonLabel: "Refuza oferta",
		approveOfferButtonLabel: "Aproba oferta",
		productShortNameLabel: "Denumire",
		firstPriceNameLabel: "Pret original",
		discountAppliedLabel: "Denumire",
		discountLabelDiscount: "Discount",
		discountLabelDeduction: "Deductie",
		statusNameLabel: "Status ",
		rejectReasonLabel: "Motivul rejectarii ",
		offerStatus_10: "Nou",
		offerStatus_11: "Rejectat",
		offerStatus_12: "Aprobat",
		offerStatus_13: "Stearsa",

		transferButtonLabel: "Transfera ofertele selectate",
		transferFromPersonLabel: "Oferte incarcate de ",
		transferToPersonLabel: "TRANSFER LA ",

		discountFilterLabel: "Tip discount: ",
		discountFilter_ALL: "Toate",
		discountFilter_DEDUCTION: "Deductie",
		discountFilter_DISCOUNT: "Discount",

		deleteOfferSuccessMessage: "Oferta a fost stearsa cu succes",
		transferOfferSuccessMessage: "Ofertele selectate au fost transferate cu succes",

		// locationValueLabel: "Loc desfasurare",
		// startDateLabel: "Perioada desfasurare (de la)",
		// endDateLabel: "Perioada desfasurare (pana la)",
		confirmRejectOfferTitle: "Ai ales sa refuzi oferta",
		confirmRejectOfferMessage: "Te rog sa ne spui care este motivul pentru care vrei sa refuzi oferta. ",
		approveDataSuccess: "Oferta a fost aprobata cu succes",
		rejectDataSuccess: "Oferta a fost respinsa",

		confirmDeleteOfferMessage: "Sigur doresti sa stergi oferta?",

		// user management
		managementTitle: "Useri",
		managementShortDesc: "Userii din companie pe care i-ai invitat pe platforma.",
		inviteUserTitleSection: "Invita-ti colegii sa se alature platformei UpClub",
		inviteUserShortDesc: "Invita-ti colegii sa se alature platformei Up Club, sa comunice cu alti antreprenori si sa listeze produse si servicii pentru compania ta. ",
		roleLabel: "Tip cont",
		userModeLabel_1: "Cont FREE",
		userModeLabel_2: "Cont PREMIUM",
		addNewUserLabel: "INVITA ACUM",

		confirmModifyAccount: "Activare cont premium pentru {name}",
		confirmModifyUserPremiumMessage: "Aceasta actiune presupune o obligatie de plata",
		confirmModifyUserMessage: "Sigur doresti sa modifici userul?",
		confirmDeleteUserMessage: "Sigur doresti sa stergi userul?",
		downgradeFreeButtonLabel: "RETROGRADARE LA FREE",
		upgradePremiumButtonLabel: "UPGRADARE LA PREMIUM",
		approvePremiumButtonLabel: "APROBA PREMIUM",
		rejectPremiumButtonLabel: "RESPINGE PREMIUM",
		pendingButtonLabel: "CERERE IN ASTEPTARE",

		notificationsChooseOptionYes: "Da",
		notificationsChooseOptionNo: "Nu",

		textReadAndAgree: "Am citit si sunt de acord cu ",

		companyManagementTitle: "Gestiune acces cont",
		companyManagementDescription:
			"Gestioneaza accesul la contul tau de companie al colegilor si colaboratorilor",
		userSettingsDescription:
			"Gestioneaza accesul la uponline si la companiile pe care ai fost invitat sa le administrezi",
		manageUsersTitleSection:
			"Gestioneaza utilizatorii care au acces la contul tau",
		manageCompaniesTitleSection: "Gestioneaza companiile la care ai acces",
		adminInformationTitleSection: "Informatii admin",


		// Change Password Form
		placeholderOldPassword: "Parola actuala",
		passwordCriteria1Text: "Minim 8 caractere",
		passwordCriteria2Text: "Minim un caracter litera",
		passwordCriteria3Text: "Minim un caracter numeric",
		// error messages
		errorMessage_BS12: "Parola curenta nu este corecta",
		errorMessage_500:
			" Serverul nu raspunde. <br /> Te rugam sa astepti cateva minute si sa incerci din nou.",
		errorMessage_PSB1:
			"Ai incercat autentificarea de prea multe ori cu o parola gresita. <br/> Contul tau este blocat {param} minute",
		errorMessage_PSB2:
			"Ai incercat sa te autentifici de prea multe ori cu o parola gresita. <br/> Contul tau este blocat {param} ore.",
		errorMessage_PSB3:
			"Ai incercat sa te autentifici de prea multe ori cu o parola gresita. <br/> Contul tau este blocat {param} ore si {param1} minute.",
		errorMessage_LINK_EXPIRE: "Link-ul a fost deja confirmat.",

		errorMessage_403: "Utilizatorul sau parola sunt invalide!",
		errorMessage_400: "Utilizatorul sau parola sunt invalide!",
		// Read More || Read less
		readMore: "Mai mult",
		readLess: "Mai putin",

		// notificari
		notificationPageTitle: "Lista notificari",
		noNotifications: "Nu ai nici o notificare.",
		notificationAction_DELETE: "Sterge",
		notificationAction_READ: "Marcheaza ca citit",
		actionsNotificationText:
			"Pentru cele {count} notificari selectate mai sus doresti:",
		notificationActionSelect: "Administrare notificari",
		showAllNotifications: "Vezi toate mesajele",
		goToSetting: "Mergi la Setari",
		deleteNotification: "Sterge mesajul",


		// membership
		membershipTitle: "Premium",
		membershipShortDesc: "Cont premium",
		membershipBox1: "Te bucuri de peste	60 de oferte premium.",
		membershipBox2: "Te bucuri de peste	60 de oferte premium.",
		membershipBox3: "Iti poti lista oricat de multe produse si servicii doresti avand membership premium.",
		membershipRequestButton: "VREAU MEMBERSHIP UPCLUB",
		membershipSuccess: "Felicitari, acum esti membru UpClub si poti adauga ofertele tale!",
		membershipText: "{name},  ne bucuram ca ai un cont premium. Iata care sunt beneficiile care vin la pachet cu acesta: vei putea lista oferte pentru produse si servicii, evenimente si training-uri pentru compania ta si vei putea accesa datele de contact ale celorlalti antreprenori. Varietatea produselor si serviciilor te vor ajuta sa iei decizia optima pentru compania din care faci parte. ",
		addOffersButton: "ADAUGA OFERTE",

		// search company
		searchPageName: "Cauta companie",
		searchByCodall: "Codall/Cod client",
		searchByProduct: "Produs",
		searchByCompanyName: "Nume companie",
		searchByFiscalCode: "Cod fiscal",
		searchByProformNumber: "Nr. Proforma",
		searchButtonLabel: "Cauta",
		searchNoCompanies: "Nu exista nici o companie.",

		// cookies
		cookieTab1: "Cookies",
		cookieTab2: "Date personale",
		cookieTab3: "Optiuni marketing",
		cookiesGeneralInfo: "Informatii generale",
		cookiesGeneralInfoDescription:
			"<br />Cookie-urile sunt fisiere text pe care browser-ul tau le stocheaza cand vizitezi site-ul, pentru ca acesta sa tina minte preferintele tale si anumite informatii(cum ar fi limba afisata si optiunile setate in site), astfel incat sa-ti ofere o experienta de navigare personalizata si optimizata din punct de vedere afisare si continut. Cookie-urile contin informatii despre IP-ul tau, despre tipul de browser, despre device, despre anumite preferinte de navigare setate de tine pe site, chiar daca nu esti logat. Cookie-urile nu te pot identifica in mod direct, insa IP-ul tau poate fi asociat cu o tara, o localitate si un furnizor de acces la Internet. Cookie-urile pot fi stocate in browser de catre site-ul vizitat sau de catre servicii partenere de analiza de trafic sau de publicitate. <br /> Pentru ca respectam dreptul tau la confidentialitate, poti alege activarea sau dezactivarea anumitor tipuri de cookie-uri, preferinte pe care le poti exprima in continuare.",
		cookiesNecessary: "Cookie-uri necesare",
		cookiesMandatory: "Obligatorii",
		cookiesNecessaryDescription:
			"<br /> Cookie-urile necesare sunt esentiale pentru functionarea site-ului si nu pot fi dezactivate. Acestea sunt cookie-uri care stocheaza informatii legate de preferintele pe care le declare in site: acceptarea politicilor, inclusive cea de cookie-uri, preferinta de limba, informatii si preferinte de login. Aceste cookie-uri nu contin date personale prin care poti fi identificat in mod direct. <br /> <br />Poti bloca aceste cookie-uri din setarile browser-ului tau, dar atunci unele parti ale site-ului nu vor functiona corect sau nu vor functiona deloc.<br /> <br />Cookie-urile utilizate de site: <br /> <br />",
		cookiesNecessaryNecessary:
			"necessary - necesar pentru afisarea continutului si pastrarea preferintelor tale",
		cookiesNecessarySession:
			"session - cookie temporar, necesar pentru validarea sesiunii tale",
		cookiesFunctional: "Cookie-uri functionale",
		cookiesAllow: "Permite",
		cookiesDontAllow: "Oprite",
		cookiesFunctionalDescription:
			"<br />Acestea sunt cookie-uri care ne permit sa iti afisam continut personalizat in site, in functie de activitatea ta anterioara pe site. Unele dintre aceste cookie-uri pot fi parte ale unor module create de alte companii din domeniul informatic si folisite de noi in dezvoltarea si gestionarea site-ului. <br /> <br />Cookie-urile utilizate de site: <br /> <br />",
		cookiesFunctionalDescriptionLink:
			" Acest tip de cookie nu este utilizat de site la acest moment. Daca acest lucru se va schimba, vei fi anuntat de necesitatea reinnoirii preferintelor tale si a reconfirmarii acordului cu politica de cookie-uti",
		cookiesAnalisys: "Cookie-uri de analiza de trafic",
		cookiesAnalisysDescription:
			"<br />Cookie-urile de analiza de trafic stocheaza informatii de ordin statistic, anonim, despre data si ora fiecarei vizite pe site, durata vizitei, paginile accesate si actiunile in fiecare pagina. Unele cookie-uri pot inregistra miscarea cursorului pe ecran, pentru a determina care au fost zonele de interes urmarite de vizitatorii site-ului.<br /><br />Aceste cookie-uri sunt instalate de module ale unor parti terte, utilizate in dezvoltarea site-ului, si procesate de acestea in mod anonimizat, pentru a ne furniza rapoarte centralizate despre traficul pe site.<br /><br />Cookie-urile utilizate de site:<br /><br />",
		cookiesAnalisysDescriptionLink: "Google Analytics",
		cookiesMarketing: "Cookie-uri de marketing",
		cookiesMarketingDescription:
			"<br />Cookie-urile de marketing sunt instalate de servicii terte, ale unor companii cu care noi derulam activitati de marketing si publicitate. Aceste cookie-uri sunt folosite de aceste companii de publicitate pentru a crea profiluri de marketing si de a-ti afisa reclame pe alte site-uri pe care le vizitezi. Informatiile prelucrate prin aceste cookie-uri nu sunt date care te pot identifica direct, insa acestea fac identificarea unica a browser-ului tau. Acest proces ne ajuta pe noi sa nu cheltuim pe reclame afisate unui public neinteresat de produsele noastre, iar pe tine te ajuta sa primesti mai putine reclame irelevante, si mai multe informatii despre produse si servicii care te-ar putea interesa in mod real. Prin acest proces NU se face targetare pentru marketing direct. Nu vei primi informatii prin e-mail, SMS sau alt canal direct de comunicare directa in urma acceptarii acestui tip de cookie. <br /> <br /> Cookie-urile utilizate de site:<br /> <br />",
		cookiesMarketingDescriptionLink:
			"Acest tip de cookie nu este utilizat de site la acest moment. Daca acest lucru se va schimba, vei fi anuntat de necesitatea reinnoirii preferintelor tale si a reconfirmarii acordului cu politica de cookie-uti",
		gdprP1:
			"Daca ai completat un formular pe site cu datele tale personale pe acest site, trebuie sa stii ca in perioada in care detinem si prelucram datele tale, ai dreptul de a ne solicita in orice moment accesul la date, rectificarea sau stergerea acestora, sau restrictionarea prelucrarii. Ai de asemenea dreptul de a te opune prelucrarii si dreptul de a solicita portarea datelor catre alt operator. Poti oricand sa retragi consimtamantul de prelucrare. Trebuie sa mai stii ca pentru orice suspiciune de nereguli privind prelucrarea datelor dvs, puteti depune o plangere la Autoritatea Nationala de Supraveghere a Prelucrarii Datelor cu Caracter Personal",
		gdprP2:
			"Iti reamintim aici toate conditiile de prelucrare de date personale pe care le colectam prin intermediul acestui site:",
		gdprTitle:
			"Informare privind prelucrarea datelor personale colectate prin acest formular",
		gdprP3:
			"<b>Identitatea operatorului de date</b> <br />Datele completate in acest formular sunt prelucrate de compania Up Romania, cu sediul in Calea Serban Voda, nr. 206, Building A, Cladirea U-Center, Bucuresti, sector 4, 040215. Telefon: 0 800 802 802 (apel gratuit), e-mail: info@upromania.ro",
		gdprP4:
			"<b>Scopul prelucrarii</b> <br />Datele colectate in formularele acestui site sunt prelucrate in scopul gestionarii solicitarilor de propuneri de afaceri si pentru raspunsurile la intrebari, sugestii sau sesizari legate de activitatea comerciala a Operatorului. <br />Datele colectate in formularul de abonare la newsletter sunt prelucrate in scop de marketing direct, pentru informarea periodica in legatura cu noutatile din domeniul de activitate al operatorului.",
		gdprP5:
			"<b>Temeiul juridic</b> <br />Prelucrarea datelor colectate prin intermediul site-ului, si la adresa de e-mail mentionata, se deruleaza sub temeiul juridic reglementat de Regulamentul General pentru Protectia Datelor (GDPR) la Art. 6, lit. b – executarea unui contract sau demersuri in vederea incheierii unui contract.Datele colectate in formularul de abonare la newsletter sunt prelucrate in temeiul legal reglementat de GDPR la Ar. 6, lit a – consimtamantul persoanei vizate.",
		gdprP6:
			"<b>Datele prelucrate</b> <br />Categoriile de date pe care le prelucram sunt datele tale de identificare si contact (nume, prenume, data nasterii, telefon, e-mail, compania angajatoare, domeniul de activitate al companiei angajatoare), precum si datele colectate automat de website (IP si detalii tehnice ale sistemului de pe care vizitezi site-ul - detalii in Politica de Cookies).",
		gdprP7:
			"<b>Perioada prelucrarii</b> <br />Datele completate in formularele acestui site vor fi prelucrate in scopul declarat si stocate pentru un termen de maxim 6 luni de la data completarii. Dupa expirarea acestei perioade, datele tale vor fi sterse din aceasta baza de date. Datele colectate in formularul de abonare la newsletter vor fi prelucrate pe o perioada de maxim 3 ani. Daca acordul de prelucrare nu va fi prelungit de persoana vizata in acest interval, datele vor fi sterse.",
		gdprP8:
			"<b>Modul de prelucrare</b> <br />Datele sunt accesate de angajatii Up Romania responsabili pentru gestionarea fiecarui tip de solicitare si sunt utilizate pentru comunicarea raspunsurilor la solicitarile facute. Datele colectate in formularul de abonare la newsletter sunt stocate si extrase periodic pentru trimiterea de newslettere catre destinatarii abonati.",
		gdprP9:
			"<b>Confidentialitate</b> <br />Datele tale nu vor fi utilizate in niciun alt scop, nu vor fi dezvaluite catre terti si nu vor fi transferate in strainatate.",
		gdprP10:
			"<b>Drepturile tale</b> <br />In perioada in care detinem si prelucram datele tale, ai dreptul de a ne solicita in orice moment accesul la date, rectificarea sau stergerea acestora, sau restrictionarea prelucrarii. Ai de asemenea dreptul de a te opune prelucrarii si dreptul de a solicita portarea datelor catre alt operator. Poti oricand sa retragi consimtamantul de prelucrare. Trebuie sa mai stii ca pentru orice suspiciune de nereguli privind prelucrarea datelor dvs, puteti depune o plangere la Autoritatea Nationala de Supraveghere a Prelucrarii Datelor cu Caracter Personal (www.dataprotection.ro)",
		gdprP11:
			"<b>Modalitati de exercitare a drepturilor</b> <br />Pentru orice solicitare legata de datele tale personale, in procesul de exercitare a drepturilor mentionate in capitolul anterior, poti contacta Operatorul printr-un e-mail trimis la adresa: info@upromania.ro",
		gdprP12:
			"Pentru orice solicitare legata de datele tale personale in vederea exercitarii drepturilor tale legale, te rugam ne trimiti un e-mail la adresa:",
		gdprP13: "Te rugam sa mentionezi in solicitarea trimisa:",
		gdprLi1: "Numele",
		gdprLi2: "Prenumele",
		gdprLi3:
			"Adresa de e-mail si/sau numarul de telefon mobil care fac obiectul solicitarii (daca este cazul)",
		gdprLi4:
			"Tipul solicitarii si cat mai multe detalii legate de contextul prelucrarii datelor la care se refera solicitarea, pentru a putea identifica in sistemul nostru istoricul prelucrarilor si solutia corecta la solicitarea adresata",
		gdprLi5:
			"Adresa de e-mail si/sau numarul de telefon mobil la care te putem contacta pentru intrebari sau informari legate de solicitarea adresata.",
		gdprP14:
			"Acest site nu foloseste un sistem de conturi web. Pentru orice solicitare legate de datele personale, inclusive retragerea consimtamantului de prelucrare, dezabonare sau oric alt drept al tau legat de datele personale, te rugam sa ne trimiti un e-mail la",

		// contact
		feedbackFormTitle: "Trimite-ne un feedback",
		contactPerson: "Persoana de contact",
		commercialPerson: "Gestionar",
		workingHours: "Programul de lucru: Luni - Vineri, 8:30 - 17:30",
		commerceRegisterID: "Numar inregistrare Registrul Comertului",
		vat: "CUI",
		registeredAddressTitle: "Adresa sediului social",
		registeredAddressText1:
			"Calea Serban Voda, nr. 206, Building A, Cladirea U-Center, Bucuresti, sector 4",
		registeredAddressText2: "cod postal 040215",
		mailingAddressTitle: "Adresa de corespondenta",
		mailingAddressText1:
			"Calea Serban Voda nr. 206, cladirea U-Center, Building A, etaj 8, sector 4, Bucuresti.",
		mailingAddressText2: "cod postal 042015",

		// notificari clienti
		createNotificationTitle: "Creaza o notificare",
		createNotificationSubject: "Subiect",
		createNotificationBody: "Mesaj",
		createNotificationValidity: "Valabilitate",
		createNotificationTarget:
			"Alege angajatii carora doresti sa le trimiti mesajul",
		createNotificationTargetAllEmployees: "Toti angajatii",
		createNotificationTargetSelectEmployees: "Selecteaza angajatii",
		createNotificationSentButton: "Trimite mesaj",
		notificationListSend: "Lista notificari trimise",
		notificationListReceived: "Lista notificari primite",
		notificationLabelEmployee: "Angajati",


		// manage account

		userTypeLabel_CST: "Client",
		userTypeLabel_AFF: "Afiliat",
		userModeLabel_MASTER: "Admin",
		userModeLabel_USER: "Utilizator",
		userModeLabel_EDITOR: "Editor",
		rightsLabel: "Drepturi",
		userClientRightsLabel_MASTER: "Admin",
		userClientRightsLabel_USER:
			"Utilizatorul are dreptul de a utiliza toate functionalitatile existente in contul tau uponline.ro, insa nu poate modifica sau adauga informatii referitoare la compania ta precum puncte de lucru, informatii POS sau persoane de contact.",
		userClientRightsLabel_EDITOR:
			"Editorul are dreptul de a utiliza toate functionalitatile existente in contul tau uponline.ro si poate modifica sau adauga informatii referitoare la compania ta precum puncte de lucru, informatii POS sau persoane de contact..",
		userAffiliateRightsLabel_USER:
			"Utilizatorul are dreptul de a utiliza toate functionalitatile existente in contul tau uponline.ro, insa nu poate modifica sau adauga informatii referitoare la compania ta precum puncte de lucru, informatii POS sau persoane de contact.",
		userAffiliateRightsLabel_EDITOR:
			"Editorul are dreptul de a utiliza toate functionalitatile existente in contul tau uponline.ro si poate modifica sau adauga informatii referitoare la compania ta precum puncte de lucru, informatii POS sau persoane de contact",
		codallLabel: "Cod companie",
		typeUPPartner: "Tip partener UP",
		deleteCompanyText: "Esti sigur ca doresti stergerea companiei?",
		deleteLastCompanyText:
			"Esti sigur ca doresti stergerea companiei? In cazul care aceasta va fi stearsa nu vei mai avea acces la platforma UpOnline.",
		addUserSuccessMessage: "Utilizatorul a fost creat cu succes!",
		addUserInviteSuccessMessage: "Utilizatorul a fost invitat cu succes!",
		modifyUserSuccessMessage: "Utilizatorul a fost modificat cu succes!",
		deleteUserSuccessMessage: "Utilizatorul a fost sters cu succes!",
		requestPremiumSuccessMessage: "Cererea de upgradare la premium a fost trimisa administratorului.",

		companyStatus_true: "Activ",
		companyStatus_false: "Inctiv",

		createMandateTitle: "Confirmare document de imputernicere",
		createUserTitle: "Creaza contul",
		finishButtonLabel: "FINALIZEAZA",

	},
];
